import { Head } from '@inertiajs/react'
import { LpNavbar1 } from '@/components/pro-blocks/landing-page/lp-navbars/lp-navbar-1'
import { HeroSection2 } from '@/components/pro-blocks/landing-page/hero-sections/hero-section-2'
import { ProblemSection } from '@/components/pro-blocks/landing-page/problem-section'
import { BentoGrid6 } from '@/components/pro-blocks/landing-page/bento-grids/bento-grid-6'
import { FeatureSection9 } from '@/components/pro-blocks/landing-page/feature-sections/feature-section-9'
import { HowItWorksDetailed } from '@/components/pro-blocks/landing-page/how-it-works-detailed'
import { StatsSection4 } from '@/components/pro-blocks/landing-page/stats-sections/stats-section-4'
import TestimonialsSection1 from '@/components/pro-blocks/landing-page/testimonials-sections/testimonials-section-1'
import { PricingSection3 } from '@/components/pro-blocks/landing-page/pricing-sections/pricing-section-3'
import { FaqSection2 } from '@/components/pro-blocks/landing-page/faq-sections/faq-section-2'
import { FinalCTA } from '@/components/pro-blocks/landing-page/final-cta'
import { Footer1 } from '@/components/pro-blocks/landing-page/footers/footer-1'

export default function Landing() {
  return (
    <>
      <Head title="FeedbackIQ - Анализ обращений клиентов" />
      <main>
        <LpNavbar1 />
        <HeroSection2 />
        <ProblemSection />
        <BentoGrid6 />
        <TestimonialsSection1
          quote="До FeedbackIQ я тратил каждый понедельник на чтение обращений. После внедрения — полная картина за 30 минут. Мы поймали критический баг через 2 часа после первого обращения."
          authorName="Михаил К."
          authorRole="Head of Product, CRM-платформа"
          result="Время обнаружения проблем: с 5 дней до 2 часов"
        />
        <FeatureSection9 />
        <HowItWorksDetailed />
        <StatsSection4 />
        <TestimonialsSection1
          quote="Мы получаем 600+ обращений в неделю. Раньше брала случайную выборку. Теперь вижу все паттерны автоматически. Споры на встречах закончились за минуту."
          authorName="Анна С."
          authorRole="Senior Product Manager, Маркетплейс"
          result="Решения принимаются в 3 раза быстрее"
        />
        <PricingSection3 />
        <FaqSection2 />
        <FinalCTA />
        <Footer1 />
      </main>
    </>
  )
}
